import { CircleBranding } from 'src/api/circles';

/**
 * Fonts a circle can pick in Edit Circle. The font files and their
 * `@font-face` rules live in `brandFonts.css`; a file is only downloaded when
 * a circle that uses the family is on screen.
 */
export type BrandFontOption = {
  id: string;
  label: string;
  /** Font stack for body text. */
  body: string;
  /** Font stack for headings. */
  heading: string;
  /** When set, only circles with this special code are offered the font. */
  onlyForSpecialCode?: string;
};

export const BRAND_FONT_OPTIONS: BrandFontOption[] = [
  {
    id: 'general-sans',
    label: 'General Sans',
    body: "'General Sans', sans-serif",
    heading: "'General Sans', sans-serif",
  },
  {
    // Licensed to Ordtilhandling AS, so it is only offered to OTH circles
    id: 'gt-pressura',
    label: 'GT Pressura (Ordtilhandling)',
    body: "'GT Pressura Extended', Arial, sans-serif",
    heading: "'GT Pressura', Arial, sans-serif",
    onlyForSpecialCode: 'OTH',
  },
];

/** The option a branding object currently uses, if it is one of ours. */
export const findBrandFontOption = (
  branding?: CircleBranding | null
): BrandFontOption | undefined =>
  BRAND_FONT_OPTIONS.find((option) => option.body === branding?.font_family);

/** Options to offer for a circle: the open ones plus the one already in use. */
export const brandFontOptionsFor = (
  specialCode?: string | null,
  branding?: CircleBranding | null
): BrandFontOption[] => {
  const code = specialCode?.trim().toUpperCase();
  const current = findBrandFontOption(branding);
  return BRAND_FONT_OPTIONS.filter(
    (option) =>
      !option.onlyForSpecialCode ||
      option.onlyForSpecialCode === code ||
      option.id === current?.id
  );
};
